import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  private stateAbbreviationSource = new BehaviorSubject<string>(null);
  stateAbbreviation$: Observable<string> = this.stateAbbreviationSource.asObservable();

  setStateAbbreviation(value: string): void {
    this.stateAbbreviationSource.next(value);
  }

  getStateAbbreviation(): string {
    return this.stateAbbreviationSource.getValue();
  }
}